import { Box, useTheme } from '@mui/material';

function SubSection({ children, showError = false, error = null, ...props }) {
  const theme = useTheme();
  return (
    <Box
      style={{
        border: `1px solid ${showError && error ? theme.palette.error.main : '#ccc'}`,
        borderRadius: '10px',
        padding: '8px',
      }}
      {...props}>
      {children}
    </Box>
  );
}

export default SubSection;
